module.exports = __webpack_public_path__ + "img/Saint Kitts and Nevis.8b818342.svg";